import request, { post, get } from "@/utils/request";
import { ouchnCustom } from "../../service";

// 我的书架 学习记录列表
export function queryLearningRecord(data) {
  return request({
    url:
      ouchnCustom +
      "/device/LearningRecord/queryLearningRecord?pageNum=" +
      data.pageNum +
      "&" +
      "pageSize=" +
      data.pageSize,
    method: "get",
    data,
  });
}
// 查询考试次数和答题数量
export function queryAnswerNum(data) {
  return request({
    url: ouchnCustom + "/device/paper/queryAnswerNum?goodsId=" + data.goodsId,
    method: "get",
  });
}
// 我的书架 划线/笔记/书签相关统计
export function queryLearningRecordByInfo(data) {
  return request({
    url:
      ouchnCustom +
      "/device/LearningRecord/queryLearningRecordByInfo?goodsId=" +
      data.goodsId,
    // token: true,
    method: "get",
  });
}
//查询用户笔记、书签、划线商品列表信息
export function queryMyNoteInfo(data) {
  return request({
    url:
      ouchnCustom +
      "/device/LearningRecord/queryMyNoteInfo?goodsId=" +
      data.goodsId +
      "&" +
      "pageNum=" +
      data.pageNum +
      "&" +
      "pageSize=" +
      data.pageSize +
      "&" +
      "type=" +
      data.type,
    token: true,
    method: "get",
  });
}
// 获取用户笔记、书签、划线商品列表
export function queryMyNoteList(type, pageNum, pageSize) {
  return request({
    url:
      ouchnCustom +
      "/device/LearningRecord/queryMyNote?type=" +
      type +
      "&" +
      "pageNum=" +
      pageNum +
      "&" +
      "pageSize=" +
      pageSize,
    token: true,
    method: "get",
  });
}
//查询用户笔记、书签、划线商品列表数量
export function queryMyNoteNumAndBookNum(type) {
  return request({
    url:
      ouchnCustom +
      "/device/LearningRecord/queryMyNoteNumAndBookNum?type=" +
      type,
    token: true,
    method: "get",
  });
}
//根据图书删除
export function delByBookId(data) {
  return request({
    url:
      ouchnCustom +
      "/device/LearningRecord/delByBookId?ids=" +
      data.ids +
      "&" +
      "type=" +
      data.type,
    token: true,
    method: "post",
  });
}
// export const delByBookId = (data) =>
//   post(ouchnCustom + "/device/LearningRecord/delByBookId", data, {
//     disableToken: true,
//   });
//根据笔记、书签、划线删除
// export const delById = (data) =>
//   post(ouchnCustom + "/device/LearningRecord/delById", data);
export function delById(data) {
  return request({
    url: ouchnCustom + "/device/LearningRecord/delById?ids=" + data.ids,
    token: true,
    method: "post",
    contentType: "application/x-www-form-urlencoded",
  });
}

//获取用户每月学习情况
export function getReadTime(query) {
  return request({
    url: ouchnCustom + "/device/LearningRecord/getReadTime",
    method: "GET",
    params: query,
  });
}

//获取用户近半年的学习数据
export function queryStatistics() {
  return request({
    url: ouchnCustom + "/device/LearningRecord/queryStatistics",
    method: "GET",
  });
}

//获取用户近6年的学习数据
export function queryStatisticsYear() {
  return request({
    url: ouchnCustom + "/device/LearningRecord/queryStatisticsYear",
    method: "GET",
  });
}
